import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { AccessibilityWidget } from "./components/AccessibilityWidget";
import { ScrollToTop } from "./components/ScrollToTop";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Services } from "./pages/Services";
import { Team } from "./pages/Team";
import { Testimonials } from "./pages/Testimonials";
import { Contact } from "./pages/Contact";
import { AccessibilityStatement } from "./pages/AccessibilityStatement";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/team" element={<Team />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/accessibility" element={<AccessibilityStatement />} />
          </Routes>
        </main>
        <Footer />
        <AccessibilityWidget />
      </BrowserRouter>
    </div>
  );
}

export default App;
